import {
  CENTS_PER_UNIT,
  EVENT_BEGIN_CHECKOUT,
  EVENT_PAGE_VIEW,
  EVENT_PURCHASE,
} from "./constants"

// Item de conversão (agnóstico). Só ids de plano/variante — NUNCA PII/secret no dataLayer.
export type AnalyticsItem = {
  itemId: string
  quantity?: number
}

// Contrato de evento agnóstico de provider — união discriminada por `name`. O sink é o
// window.dataLayer (convenção neutra); o tag do vendor no cutover consome estes shapes.
export type PageViewEvent = {
  name: typeof EVENT_PAGE_VIEW
  path: string
}

export type BeginCheckoutEvent = {
  name: typeof EVENT_BEGIN_CHECKOUT
  currency: string
  itemId: string
  value?: number
}

export type PurchaseEvent = {
  name: typeof EVENT_PURCHASE
  transactionId: string
  currency: string
  value: number
  items: AnalyticsItem[]
}

export type AnalyticsEvent = PageViewEvent | BeginCheckoutEvent | PurchaseEvent

export function pageViewEvent(path: string): PageViewEvent {
  return { name: EVENT_PAGE_VIEW, path }
}

/**
 * begin_checkout. Money chega em centavos (inteiro); o `value` do evento é em unidade
 * maior de moeda (centavos/100), convenção dos eventos de conversão. amountCents é
 * opcional aqui (o CTA da Vitrine não tem o preço à mão, só a variante).
 */
export function beginCheckoutEvent(input: {
  currency: string
  itemId: string
  amountCents?: number
}): BeginCheckoutEvent {
  const event: BeginCheckoutEvent = {
    name: EVENT_BEGIN_CHECKOUT,
    currency: input.currency,
    itemId: input.itemId,
  }
  if (input.amountCents !== undefined) {
    event.value = centsToMajorUnit(input.amountCents)
  }
  return event
}

/**
 * purchase (conversão). A compra que a origina chega no Épico 3 (thank-you page); esta
 * story só entrega a abstração pronta. Converte amountCents→unidade maior e default items=[].
 */
export function purchaseEvent(input: {
  transactionId: string
  currency: string
  amountCents: number
  items?: AnalyticsItem[]
}): PurchaseEvent {
  return {
    name: EVENT_PURCHASE,
    transactionId: input.transactionId,
    currency: input.currency,
    value: centsToMajorUnit(input.amountCents),
    items: input.items ?? [],
  }
}

// Centavos-inteiros → unidade maior de moeda (value convencional de conversão).
function centsToMajorUnit(amountCents: number): number {
  return amountCents / CENTS_PER_UNIT
}
